<template>
    <v-app>
        <!--編輯-->
        <v-dialog v-model="dialog" max-width="100%">
            <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>
                <v-card>
                    <v-card-title>
                        <span class="title">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap column>
                                <v-flex xs12 sm6 md4 v-for="col in dialogKeys" :key="col.value">
                                    <div v-if="col.value === 'birthday' || col.value === 'startDate' || col.value === 'endDate'">
                                        <span class="subheading">{{col.text}}</span>
                                        <date-time-tool
                                                        :dateInfo="editedItem[col.value]"
                                                        :disabled="false" :propertyKey="`birthday`">
                                        </date-time-tool>
                                    </div>
                                    <v-layout row wrap v-else-if="col.value === 'city'">

                                    </v-layout>
                                    <div v-else-if="col.value === 'address'">
                                        <v-text-field v-model="editedItem[col.value]" :label="col.text"
                                                      :rules="col.rules"
                                                      :disabled="col.disabled"
                                                      :required="col.required"></v-text-field>
                                    </div>
                                    <div v-else-if="col.value === 'creditPrice'">
                                        <span class="subheading">期數x期付</span><br/>
                                        <v-text-field v-if="isAdmin || isAccounting"
                                                      v-model="editedItem[col.value]" :label="col.text"
                                                      :rules="col.rules"
                                                      :disabled="col.disabled"
                                                      :required="col.required"></v-text-field>
                                        <span v-else>{{editedItem[col.value]}}</span>
                                    </div>
                                    <div v-else-if="col.value === 'station'">
                                      <span class="red--text subheading">已請示通過免查詢監理站的管轄區</span><br/>
                                      <v-text-field
                                        v-model="editedItem[col.value]" :label="col.text"
                                        :rules="col.rules"
                                        :disabled="col.disabled"
                                        :required="col.required"></v-text-field>
                                    </div>

                                    <v-text-field v-else v-model="editedItem[col.value]" :label="col.text"
                                                  :rules="col.rules"
                                                  :disabled="col.disabled"
                                                  :required="col.required"></v-text-field>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn dark text  color="red darken-1" v-if="isAdmin" flat @click="removeProfile">刪除</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn dark text  color="blue darken-1" flat @click="closeDialog">取消</v-btn>
                        <v-btn dark text  color="blue darken-1" flat @click="save"
                               :loading="loading"
                               :disabled="loading">儲存</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <list-editor :column-keys="columnKeys"
                     :items="items"
                     :loading="loading"
                     :showSearchBar="true"
                     :showAddButton="true"
                     :show-export-button="true"
                     :show-search-date="true"
                     :showSearchDate="true"
                     :startDate="searchInfo.startDate"
                     :endDate="searchInfo.endDate"
                     @addData="addData"
                     @editData="edit"
                     @printData="printData"
                     @saveData="save"
                     @removeData="removeData"
                     @searchData="searchData"
                     @exportData="exportData"></list-editor>
        <!--提示-->
        <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  :show-cancel="true"
                  @cancelEvent="messageDialog.cancel"
                  @confirmEvent="messageDialog.confirm">
                </alert-view>

        <v-dialog
          v-model="contactDialog.visible"
          persistent
          :max-width="isMobile ? '90%':'40%'">
          <v-card>
            <v-card-title class="headline">
              <p>更改經辦人資料</p>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout row wrap>
                    <v-flex xs12>
                    <v-toolbar
                        dark
                        color="teal">
                        <v-toolbar-title>經辦人：</v-toolbar-title>
                        <v-autocomplete
                        v-model="selectAgentId"
                        :loading="selectAgentLoading"
                        :items="agentItems"
                        :search-input.sync="searchAgent"
                        cache-items
                        class="mx-4"
                        flat
                        hide-no-data
                        hide-details
                        label="經辦姓名"
                        solo-inverted
                        item-text="displayName"
                        item-value="agentId"
                        ></v-autocomplete>
                    </v-toolbar>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark text  @click="contactDialog.visible = false">取消</v-btn>
              <v-btn class="primary" dark text  @click="contactDialog.confirm">確定</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="toolDialog.visible"
          persistent
          :max-width="isMobile ? '90%':'40%'">
          <v-card>
            <v-card-title class="headline">
              {{toolDialog.text}}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout row wrap>
                <v-flex>
                  <v-btn class="primary" dark text @click="toolEvent(1)">套印</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-btn class="primary" dark text @click="toolEvent(2)">列印</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-btn class="primary" dark text @click="toolEvent(10)">修改經辦人</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark text @click="toolDialog.visible = false">關閉</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    </v-app>
</template>

<script>
    import {getNow , exportFileToBlobUrl} from '../utils/tool';
    import ListEditor from "../../components/ListEditor";
    import dateTimeTool from "../../components/dateTimeTool";
    import MobileDetect from 'mobile-detect';
    import { mapActions, mapGetters } from 'vuex';
    import AlertView from '../../components/AlertView'
    import common from '@/mixins/common';

    const md = new MobileDetect(window.navigator.userAgent);
    export default {
        name: "MortgageList",
        components: {ListEditor, dateTimeTool, AlertView},
        data() {
            return {
                cityData: require('../../assets/taiwan_city'),
                cityList: [],
                areaList: {},
                isMobile: md.phone(),
                loading: false,
                valid: true,
                dialog: false,
                editedIndex: -1,
                editedItem: {
                    profileId: Math.uuidFast(),
                    memberId: '',
                    name: '',
                    birthday : {
                        year: '',
                        month: '',
                        day: '',
                        isRepublic: true,
                    },
                    city:'',
                    area:'',
                    address:'',
                    startDate: {
                        year: '',
                        month: '',
                        day: '',
                        isRepublic: true,
                        disabled:false,
                    },
                    endDate: {
                        year: '',
                        month: '',
                        day: '',
                        isRepublic: true,
                        disabled:false,
                    },
                    carType: '',
                    carEngineType: '',
                    carId: '',
                    engineId: '',
                    vendorId: '',
                    carYear:'',
                    publishDate: '',
                    station: '',
                    creditPrice: 0,
                    createDate: getNow(),
                    comment :''
                },
                defaultItem:{
                    profileId: Math.uuidFast(),
                    memberId: '',
                    name: '',
                    birthday : {
                        year: '',
                        month: '',
                        day: '',
                        isRepublic: true,
                    },
                    city:'',
                    area:'',
                    address:'',
                    startDate: {
                        year: '',
                        month: '',
                        day: '',
                        isRepublic: true,
                    },
                    endDate: {
                        year: '',
                        month: '',
                        day: '',
                        isRepublic: true,
                        disabled: false,
                    },
                    carType: '普通重機',
                    carEngineType: '',
                    carId: '',
                    engineId: '',
                    vendorId: '',
                    carYear:'',
                    publishDate: '',
                    station: '',
                    creditPrice: 90000,
                    createDate: getNow(),
                    comment :''
                },
                messageDialog: {
                    title: '',
                    text: '',
                    visible: false,
                    confirm: () => {
                    },
                    cancel: () => {
                    },
                },
                items:[],
                contactDialog: {
                    visible: false,
                    confirm:()=>{},
                    cancel:()=>{},
                },
                selectAgentLoading:false,
                selectAgentId:null,
                searchAgent:null,
                agentItems:[],
                toolDialog: {
                    title: '',
                    text: '',
                    visible: false,
                    confirm: () => {
                    },
                    cancel: () => {
                    },
                },

                searchInfo:{
                    startDate:'',
                    endDate:'',
                    keyword:''
                }
            }
        },
        created(){
            const now = new Date();
            const end = new Date(now.getFullYear() + 10, now.getMonth(), now.getDate());
            this.defaultItem.startDate.year = `${now.getFullYear()-1911}`;
            this.defaultItem.startDate.month = `${now.getMonth()+1 < 10 ? '0'+(now.getMonth()+1) : now.getMonth()+1}`;
            this.defaultItem.startDate.day = `${now.getDate() < 10 ? '0'+(now.getDate()) : now.getDate()}`;
            this.defaultItem.endDate.year = `${end.getFullYear()-1911}`;
            this.defaultItem.endDate.month = `${end.getMonth()+1 < 10 ? '0'+(end.getMonth()+1) : end.getMonth()+1}`;
            this.defaultItem.endDate.day = `${end.getDate() < 10 ? '0'+(end.getDate()) : end.getDate()}`;

            this.cityData.taiwan.forEach((city) => {
                this.cityList.push(city.city);
                this.areaList[city.city] = city.area;
            });
            this.setDefualtDate();
            this.loadData();
        },
        watch:{
            searchAgent(val){
                this.querySelections(val);
            }
        },
        mixins:[common],
        computed: {
            ...mapGetters(['getUserInfo', 'getAgentList']),
            formTitle() {
                return this.editedIndex === -1 ? '新增' : '編輯'
            },
            columnKeys() {
                let list =  [
                    { value: 'delete', text: '刪除', sortable: false  ,required: false},
                    { value: 'tools', text: '編輯', sortable: false  ,required: false},
                    { value: 'print', text: '其他工具', sortable: false  ,required: false},
                    { value: 'parentAgentName', text: '經銷', sortable: true  ,required: true},
                    { value: 'memberId', text: '身分證/統一編號', sortable: false  ,required: true},
                    { value: 'name', text: '車主名稱', sortable: true  ,required: true},
                    { value: 'birthday', text: '出生日期', sortable: true  ,required: true},
                    { value: 'city', text: '縣市', sortable: false ,required: true, disabled:true , rules: [
                            v => !!v || '請選擇縣市！',
                        ],},
                    { value: 'address', text: '戶籍地址', sortable: false ,required: true, disabled:false , rules: [
                            v => !!v || '請填寫地址！',
                        ],},
                    { value: 'startDate', text: '契約生效日', sortable: true  ,required: true},
                    { value: 'endDate', text: '契約終止日', sortable: true  ,required: true},
                    { value: 'creditPrice', text: '期數x期付', sortable: true  ,required: true, disabled:true},
                    { value: 'station', text: '監理所', sortable: true  ,required: false, disabled:true},
                    { value: 'carId', text: '牌照號碼', sortable: true  ,required: true},
                    { value: 'vendorId', text: '廠牌', sortable: true  ,required: true},
                    { value: 'carYear', text: '出廠年份', sortable: true  ,required: true},
                    { value: 'engineId', text: '引擎號碼/車身號碼', sortable: true  ,required: true},
                    { value: 'carType', text: '牌照類別', sortable: true  ,required: true},
                    { value: 'carEngineType', text: '型式', sortable: true  ,required: true},
                    { value: 'createDate', text: '建立時間', sortable: true  ,required: false , disabled: true },
                    { value: 'comment', text: '備註', sortable: false  ,required: false},
                ];
                if (this.isAdmin){
                    return list;
                } else {
                    return list.filter(m=>m.value !== 'delete');
                }
            },
            dialogKeys() {
                return this.columnKeys.filter(m=>m.value !== 'tools' && m.value !== 'delete' && m.value !== 'print');
            },
        },
        methods: {
            ...mapActions(['fetchMortgageList', 'saveMortgageData', 'removeMortgageData','saveContactInfo', 'fetchCreditProductInfo']),
            querySelections (v) {
                this.selectAgentLoading = true
                this.agentItems = this.getAgentList
                this.agentItems = this.getAgentList.filter(e => {
                return (e.displayName || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
                })
                this.selectAgentLoading = false
            },
            setDefualtDate(){
                let todayDate = new Date();
                todayDate.setMonth(todayDate.getMonth() - 1);
                let currentDate = todayDate.toISOString().substr(0, 10);
                const [thisYear, thisMonth, thisDay] = currentDate.split("-");
                this.searchInfo.startDate = `${thisYear}-${thisMonth}-01`;

                let futureDate = new Date();
                // 将当前月份加1，下移到下个月
                futureDate.setMonth(futureDate.getMonth() + 1);
                // 再获取天数即取上个月的最后一天的天数
                futureDate.setDate(0);
                let days = futureDate.getDate();

                let endDate = futureDate.toISOString().substr(0, 10);
                const [futureYear, futureMonth, futureDay] = endDate.split("-");

                this.searchInfo.endDate = `${futureYear}-${futureMonth}-${days}`;
                // let date = new Date();
                // //将当前月份加1，下移到下一个月
                // date.setMonth(date.getMonth() + 1);
                // //将当前的日期置为0，
                // date.setDate(0);
                // //再获取天数即取上个月的最后一天的天数
                // let days = date.getDate();
                // let currentDate = new Date().toISOString().substr(0, 10);
                // const [year, month, day] = currentDate.split("-");
                // this.searchInfo.startDate = `${year}-${month}-01`;
                // this.searchInfo.endDate = `${year}-${month}-${days}`;
            },
            toolEvent(index) {
                if(index === 1)
                {
                    let routeData = this.$router.resolve({name: 'MortgageView', query: {profileId: this.editedItem.profileId}});
                    window.open(routeData.href, '_blank');
                }else if(index === 2)
                {
                  let routeData = this.$router.resolve({name: 'MortgagePrintView', query: {profileId: this.editedItem.profileId}});
                  window.open(routeData.href, '_blank');
                }
                else if (index === 10) {
                    this.contactDialog.visible = true;

                    this.contactDialog.confirm = ()=>{
                        const find = this.getAgentList.find(agent => agent.agentId === this.selectAgentId);
                        if (find) {
                          this.editedItem.parentAgent = {
                            agentId: find.agentId,
                            agentNumber: find.agentNumber,
                            displayName: find.displayName,
                            parentAgent: find.parentAgent ? find.parentAgent : '',
                            salesName: find.salesName ? find.salesName : '',
                          };
                          this.loading = true;
                          this.saveMortgageData(this.editedItem)
                            .then(error => {
                              this.loading = false;
                              this.loadData();
                              this.contactDialog.visible = false;
                            });
                          // console.log(`change agent === ${JSON.stringify(this.editedItem)}`);
                        }
                    }
                }
            },
            async changeContact(data){
                const result = await this.saveContactInfo(data);
                this.loadData();
                console.log(`result === ${JSON.stringify(result)}`);
            },
            loadData(){
                this.loading = true;
                const beginDate = `${this.searchInfo.startDate} 00:00:00`
                const tempEndDate = `${this.searchInfo.endDate} 23:59:59`
                console.log(`beginDate === ${beginDate} tempEndDate === ${tempEndDate}`)
                const agentId = this.isAdmin || this.isAccounting ? '' : this.getUserInfo.agentId;
                this.fetchMortgageList({agentId: agentId}).then(results=>{
                        console.log(`results === ${JSON.stringify( results)}`)
                        this.loading = false;
                        this.items = results.filter(a => a.createDate > beginDate && a.createDate < tempEndDate);
                        this.sortSearchKeyword();
                    });
            },
            addData(){
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedItem.profileId = Math.uuidFast();
                this.editedIndex = -1;
                this.dialog = true;
                console.log(`addData ${JSON.stringify(this.editedItem)}`);
            },
            save() {
                if (this.$refs.form.validate()) {

                    if (this.editedIndex === - 1){
                        this.editedItem.parentAgent = {
                            agentId: this.getUserInfo.agentId,
                            agentNumber: this.getUserInfo.agentNumber,
                            displayName: this.getUserInfo.displayName,
                            parentAgent: this.getUserInfo.parentAgent ? this.getUserInfo.parentAgent : '',
                            salesName: this.getUserInfo.salesName ? this.getUserInfo.salesName: '',
                        };

                        const check = this.items.find(i=>i.profileId === this.editedItem.profileId);
                        if (check) {
                            this.showMessageDialog('提示',  `${this.editedItem.profileId} 資料編號重複！`, true, ()=>{
                            } , ()=>{
                            });
                            return;
                        }
                    }

                    this.loading = true;
                    this.saveMortgageData(this.editedItem).then(error=>{
                        this.loading = false;
                        this.loadData();
                        this.closeDialog();
                    });
                }
            },
            edit(item){
                this.editedItem = item;
                console.log(`edit == ${JSON.stringify(item)}`);
                this.dialog = true;
                this.editedIndex = 0;
            },
            removeData(item){
                this.showMessageDialog('提示', '是否確定要刪除？', true, ()=>{
                    this.removeMortgageData(item).then(error=>{
                        this.closeDialog();
                    });
                } , ()=>{
                });
            },
            async printData(item) {
                this.editedItem = item;
                this.toolDialog.visible = true;
            },
            searchData(search){
                console.log(`searchData ${JSON.stringify(search)}`);
                this.searchInfo.startDate = search.startDate
                this.searchInfo.endDate = search.endDate;
                this.searchInfo.keyword = search.keyword;
                this.loadData();
                // if (search.keyword !=='' || search.searchDate.length > 0){
                //     this.items = this.items.filter(item=>{
                //         const value = `${item.memberId}${item.name}${item.carId}`;
                //         if (search.searchDate && search.searchDate.length > 0) {
                //             const date1 = new Date(`${search.searchDate[0]} 00:00:00`).getTime();
                //             const date2 = new Date(`${search.searchDate[1]} 23:59:59`).getTime();
                //             const itemDate = new Date(item.createDate).getTime();

                //             if (search.keyword !=='') {
                //                 return value.indexOf(search.keyword) > -1 && (itemDate >= date1 && itemDate <= date2);
                //             } else {
                //                 return (itemDate >= date1 && itemDate <= date2);
                //             }
                //         }
                //         if (search.keyword !=='') {
                //             return value.indexOf(search.keyword) > -1;
                //         }
                //     })
                // } else {
                //     this.loadData();
                // }
            },
            sortSearchKeyword(){
                const keyWord = this.searchInfo.keyword ? this.searchInfo.keyword.trim() : '';
                if (keyWord){
                    this.items = this.items.filter(item=>{
                        const value = `${item.memberId}${item.name}${item.carId}`;
                        if (this.searchInfo.keyword !=='') {
                            return value.indexOf(this.searchInfo.keyword) > -1;
                        }
                    })
                }
            },
            removeProfile(){
                this.showMessageDialog('提示', '是否確定要刪除？', true, ()=>{
                    this.removeMortgageData(this.editedItem).then(error=>{
                        this.closeDialog();
                    });
                } , ()=>{
                });
            },
            closeDialog(){
                this.loading = false;
                this.dialog = false;
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.loadData();
            },
            exportData(){
                let list = this.items;
                const columns = [
                    { name: '經銷', key: 'parentAgentName' },
                    { name: '身分證/統一編號', key: 'memberId' },
                    { name: '車主名稱', key: 'name' },
                    { name: '出生日期', key: 'birthday' },
                    { name: '車主名稱', key: 'name' },
                    { name: '縣市', key: 'city' },
                    { name: '戶籍地址', key: 'address' },
                    { name: '契約生效日', key: 'startDate' },
                    { name: '契約終止日', key: 'endDate' },
                    { name: '期數x期付', key: 'creditPrice' },
                    { name: '監理所', key: 'station' },
                    { name: '牌照號碼', key: 'carId' },
                    { name: '廠牌', key: 'vendorId' },
                    { name: '出廠年份', key: 'carYear' },
                    { name: '引擎號碼/車身號碼', key: 'engineId' },
                    { name: '牌照類別', key: 'carType' },
                    { name: '型式', key: 'carEngineType' },
                    { name: '建立時間', key: 'createDate' },
                    { name: '備註', key: 'comment' },
                ];
                exportFileToBlobUrl('動產抵押申請資料匯出', columns , list);
            },
            showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
                this.messageDialog.title = title;
                this.messageDialog.text = text;
                this.messageDialog.visible = visible;
                const self = this;
                this.messageDialog.confirm = () => {
                    self.messageDialog.visible = false;
                    if (confirmEvent) {
                        confirmEvent();
                    }
                };

                this.messageDialog.cancel = () => {
                    self.messageDialog.visible = false;
                    if (cancelEvent) {
                        cancelEvent();
                    }
                };
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/MortgageList.vue